import { render, staticRenderFns } from "./PrimaryNavItem.vue?vue&type=template&id=70fe4336&"
import script from "./PrimaryNavItem.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PrimaryNavItem.vue?vue&type=custom&index=0&blockType=stlye&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports